import React from "react";

const Sparkles = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} aria-hidden>
    <path d="M12 2 13.8 8.2 20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8L12 2z" />
    <path d="M19 14l.9 2.6L22 17.5l-2.1.9L19 21l-.9-2.6L16 17.5l2.1-.9L19 14z" opacity="0.85" />
    <path d="M5 4l.7 1.9L7.6 6.7 5.7 7.4 5 9.3 4.3 7.4 2.4 6.7l1.9-.8L5 4z" opacity="0.7" />
  </svg>
);

export default Sparkles;
